import { GetterTree } from 'vuex'
import CenterState from './states'
import { State } from '@/store/store'
import * as _ from 'lodash'

const getters: GetterTree<CenterState, State> = {
  headerLists: (state) => {
    return state.list.column
  },
  centerLists: (state) => {
    const data = state.list.result
    const result: Array<{
      text?: string,
      value?: string,
    }> = []
    data.forEach((each) => {
      result.push({
        text: each.name,
        value: each._id,
      })
    })
    return result
  },
  itemLists: (state) => {
    return state.list.result
  },
  centerById: (state) => {
    return _.mapKeys(state.list.result, '_id')
  },
  filterLists: (state) => {
    return state.list.defaultFilter
  },
  pagination: (state) => {
    const paginationLists = {
      itemCount: state.list.itemCount,
      page: state.list.page,
      pageCount: state.list.pageCount,
    }
    return paginationLists
  },
}

export default getters
